import { useContext, useEffect, useState } from 'react'

import clsx from 'clsx'

import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { Portal } from '@tribeplatform/react-ui-kit/Portal'

import { useMobileBottomNavigation } from '../../Navbar/useMobileBottomNavigation'
import { CookieConsentPopUp } from './CookieConsentPopUp'
import { CookieConsentPreferencesModal } from './CookieConsentPreferencesModal'
import { CookieContext } from './CookieContext'
import { getCookieSettings } from './utils/cookie-settings'

export const CookieConsent = () => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(true)
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false)

  const { shouldShowCookiePopup } = useContext(CookieContext)

  const { enabled: mobileBottomNavigationEnabled } = useMobileBottomNavigation()

  useEffect(() => {
    if (
      !isPopUpOpen &&
      !isPreferencesModalOpen &&
      !getCookieSettings()?.hasUserConsent
    ) {
      setIsPopUpOpen(true)
    }
  }, [isPopUpOpen, isPreferencesModalOpen])

  const onManagePreferences = () => {
    setIsPreferencesModalOpen(true)
    setIsPopUpOpen(false)
  }

  if (!shouldShowCookiePopup) {
    return null
  }

  return (
    <>
      {isPopUpOpen && (
        <Portal>
          <Container
            size="full"
            padding={{ size: 'md', disableOnMobile: true }}
            containerProps={{
              className: clsx(
                'fixed inset-x-0',
                mobileBottomNavigationEnabled
                  ? 'bottom-10 sm:bottom-0'
                  : 'bottom-0',
              ),
            }}
          >
            <Container size="xl">
              <CookieConsentPopUp
                onManage={onManagePreferences}
                onClose={() => setIsPopUpOpen(false)}
              />
            </Container>
          </Container>
        </Portal>
      )}
      <CookieConsentPreferencesModal
        isOpen={isPreferencesModalOpen}
        onClose={() => setIsPreferencesModalOpen(false)}
      />
    </>
  )
}
